import React from "react";

const getOrdinalSuffix = (n: number) => {
  if (n === 1) return "st";
  if (n === 2) return "nd";
  if (n === 3) return "rd";
  return "th";
};

interface PurseCardProps {
  title: string;
  prizeList: string[] | number[];
  currency?: string;
}

const PurseCard = ({
  title,
  prizeList,
  currency = "$",
}: PurseCardProps) => {
  const visiblePrizes = prizeList.slice(0, 5);

  return (
    <div
      className={`flex flex-col gap-2.5 lg:gap-7.5 min-h-[165px] p-5 lg:p-7.5
                rounded-[10px] bg-tm-c-gray-950 border border-tm-c-gray-700
                lg:min-h-[200px] lg:py-6 lg:px-[30px]
                min-[1041px]:!min-h-[300px]
              `}
    >
      <span className="text-xs md:text-base text-left whitespace-pre-line">
        {title}
      </span>
      <ul className="text-base lg:text-xl my-2.5 mx-0 w-full list-none p-0 [&>li]:flex [&>li]:w-full [&>li]:justify-between">
        {visiblePrizes.map((prize: string | number, idx: number) => (
          <React.Fragment key={idx}>
            <li>
              <span>
                {idx + 1}
                <span className="align-super text-xs">
                  {getOrdinalSuffix(idx + 1)}
                </span>
              </span>
              <span className="font-medium">
                {currency}
                {prize?.toLocaleString("en-US") || 0}
              </span>
            </li>
            {idx !== visiblePrizes.length - 1 && (
              <span className="flex w-full h-[1px] bg-tm-c-gray-800 my-2" />
            )}
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};

export default PurseCard;
